import React from 'react'
import { useSelector } from 'react-redux'
import { ListItem, ListItemButton, Tooltip } from '@mui/material'
import { ListItemIcon, ListItemText } from '@mui/material'

const COLOR_FOR_HOVER = 'var(--color-blue-light)'
const stylePrimaryText = {
  fontFamily: 'Avenir Next',
  fontStyle: 'normal',
  fontWeight: 700,
  fontSize: '0.84em',
  lineHeight: '1em',
  color: '#6A6A6A',
}

const ListItemDLM = ({
  keyText,
  primary,
  secundary,
  iconType,
  children,
  simple = false,
  onClick,
  sx,
}) => {
  const _open = useSelector(state => state.drawerLeft.open)
  const widthMinDrawer = useSelector(state => state.drawerLeft.drawerWidthMin)

  return (
    <ListItem
      key={keyText}
      disablePadding
      sx={{ display: 'block', width: !_open ? widthMinDrawer : 'none', ...sx }}>
      {simple ? (
        <Tooltip title={!_open ? primary : ''} placement="left">
          <ListItemButton
            onClick={onClick}
            sx={{
              minHeight: '5vh',
              justifyContent: _open ? 'initial' : 'center',
              px: 1.6,
              '&:hover': {
                bgcolor: COLOR_FOR_HOVER,
              },
            }}>
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: _open ? 1.5 : 'auto',
                justifyContent: 'center',
              }}>
              {iconType}
            </ListItemIcon>
            <ListItemText
              primary={primary}
              primaryTypographyProps={stylePrimaryText}
              secondary={secundary}
              sx={{ display: _open ? 'inline' : 'none' }}
            />
          </ListItemButton>
        </Tooltip>
      ) : (
        children
      )}
    </ListItem>
  )
}
export default ListItemDLM
